<template>
<div class="header">
  <b-container fluid>
    <div v-if="isLogin">
      <b-row align-v="center">
        <b-col cols="3">
          <img style="padding-left: 40px" src="../assets/esec_logo.jpg">

        </b-col>
        <b-col cols="9" style="color: #e5eaed; padding-right: 40px" class="text-right" >
          <img style="padding-right: 40px; " src="../assets/iq_logo.jpg">
          <div style="display: inline-block; vertical-align: middle;">
            <el-select v-model="lenderId" style = "width: 140px; margin-top: 10px" @change="lenderChange">
                <el-option v-for="item in lenders" :key="item.id" :label="item.lenderCode" :value="item.id"></el-option>
            </el-select>
            &nbsp; | &nbsp;  {{fullName}} <br>
                      <router-link :to='""' v-on:click.native="navigateToAccountSettings" style="color: #e5eaed;">Account Settings</router-link> &nbsp; | &nbsp;
            <router-link :to='""' v-on:click.native="logout" style="color: #e5eaed;">Logout</router-link>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row align-v="center">
        <b-col>
          <img style="padding-left: 40px" src="../assets/esec_logo.jpg">
        </b-col>
        <b-col style="padding-right: 40px" class="text-right" >
          <img style="padding-right: 40px; " src="../assets/iq_logo.jpg">
        </b-col>
      </b-row>
    </div>
  </b-container>
</div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import HTTP_API from '@/utils/http-api'
import * as cognosLaunch from '../utils/cognoslaunch.js';
import Vue from 'vue';


export default({
  name: 'Header',
   data() {
     return {
      lenderId:'',
      lenders: [],
      fullName:'',
      count:0,
      loading: false
    }
   },
  computed: {
    isLogin() {
      return (this.$route.name !== 'login' && this.$route.name !== 'forgotpassword'  && this.$route.name !== 'resetpassword'
      && this.$route.name != 'cusipagreement' && this.$route.name != 'qr' && this.$route.name != 'softtoken')
    }
  },
  methods: {
    logout() {
      var vm = this
      HTTP_API.get('/base/logoff/')
      .then(response => {
        cognosLaunch.logoffCognos();
        sessionStorage.clear()
        
        setTimeout(() => {
          window.location.href = "/CR/"
        }, 1000)
      })
      .catch(function (error) {
        console.log(error.response)
      })
    },
    lenderChange(){
      var vm = this;
      vm.updateCognosInfo();
    },
    navigateToAccountSettings(){
      this.$router.push({ name: "accountsettings"})
    },
    resetAllFlag() {
      this.loading = false
    },
    updateCognosInfo(){
      var vm = this

      HTTP_API.get('/base/updatecognosinfo/' + vm.lenderId)
      .then(response => {
        cognosLaunch.logoffCognos();
        vm.$router.push({ name: "home",params: {lenderId: vm.lenderId} },)

      })
      .catch(function (error) {
        console.log(error.response)
      })
    },
    getHeaderData(){
      var vm = this
      HTTP_API.get('/base/headerinfo')
      .then(response => {
        vm.lenderId = response.data.lenderId
        vm.lenders = response.data.lenders
        vm.fullName = response.data.fullName
      })
      .catch(function (error) {
        console.log(error.response)
        
      })
    }
  },
  created() {
   
    if(this.$route.name !== 'login' && this.$route.name !== 'forgotpassword'  && this.$route.name !== 'resetpassword'
      && this.$route.name != 'cusipagreement' && this.$route.name != 'qr' && this.$route.name != 'softtoken'){
       
       if(this.count === 0){
          this.getHeaderData()
       }
       this.count = this.count + 1
    }
    window.addEventListener( "unload", this.logout);
  },
  updated() {
    if(this.$route.name !== 'login' && this.$route.name !== 'forgotpassword'  && this.$route.name !== 'resetpassword'
      && this.$route.name != 'cusipagreement' && this.$route.name != 'qr' && this.$route.name != 'softtoken'){
       
       if(this.count === 0){
          this.getHeaderData()
       }
       this.count = this.count + 1
    }
   
  }
})
</script>

<style scoped>
  .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 800px;
    background-color: #202c4c;
    color: #e5eaed;
    /* padding-left: 20px; */
    height: 89px;
    z-index: 1;
    /* line-height: 60px;
    z-index: 1; */
    /* font-size: 13.5px; */
  }

  .text-right {
    text-align: right !important;
  }
</style>
